import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { useDispatch } from 'react-redux'
import { Input } from 'components/Input/Input'
import { updateEntry } from 'apps/builder/store/actions/entries'
import {
  RequiredToggle,
  ReadOnlyToggle,
  MinMaxRange,
  NumberFieldStyleOptions,
} from 'apps/builder/components/settings/modal/shared'

import { useDefaultValueNumberValidation } from 'apps/builder/lib/hooks/smartPreviewValidationHook'

export const IncrementField = ({
  guid,
  label,
  required,
  read_only,
  default: defaultValue,
  style = style || 0,
  minimum,
  maximum,
  type,
  keyField,
}) => {
  const [isValid, errorText] = useDefaultValueNumberValidation({
    minimum,
    maximum,
    value: defaultValue,
  })
  const dispatch = useDispatch()

  const updateDefaultValue = value => {
    dispatch(
      updateEntry({
        guid,
        default: value,
      })
    )
  }

  const change = input => {
    updateDefaultValue(input)
  }

  const inputProps = {
    id: `default-${guid}`,
    value: defaultValue || '',
    placeholder: '',
    error: !isValid,
    errorText: errorText,
    update: change,
    label: 'Default Value',
  }

  const onSaveFormat = style => {
    const format = {
      0: 'Number',
      4: 'Currency',
      1: 'Increment',
      2: 'Slider',
    }
    return format[style]
  }

  const numberStyle = onSaveFormat(style)

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />
        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
          <div className="toggle-wrapper">
            <ReadOnlyToggle guid={guid} active={read_only} />
          </div>
        </div>
      </div>

      <div className="settings--format--wrapper">
        <label className="settings--label">Style</label>
        <NumberFieldStyleOptions guid={guid} selected={numberStyle} />
      </div>

      <MinMaxRange guid={guid} minimum={minimum} maximum={maximum} />

      <div className="settings--default-value">
        <Input {...inputProps} />
      </div>
    </>
  )
}
